import { ImageList, ImageListItem } from "@mui/material";
import Swiper from "./swiper";
import Dishe from "../sections/dishe";
import "../../../css/mobileScreens.css";

import i18next, { t } from "i18next";
import calories from "../../../images/Fire.svg";
import time from "../../../images/Timer.svg";
import {
  getBadgeStatusClass,
  getLocalStorageMenuItem,
  ISDARKTHEME,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileHighlightTextColor,
  setMobileTextColor,
} from "../../../utility";
import { Button, Badge, Carousel, Container } from "react-bootstrap";
import { Button as MuiButton } from "@mui/material";
import no_image from "../../../images/No_Image_Available.jpg";
import heart_full_inactive_svg from "../../../images/heart_full_inactive_svg.svg";
import heart_full_inactive_with_white from "../../../images/heart_full_inactive_with_white.svg";

import heart_full_active_svg from "../../../images/heart_full_active_svg.svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import SvgDynamicIconComponent from "../../../SvgDynamicIconComponent";
import { RWebShare } from "react-web-share";
import SuggestedOrderItem from "./suggestedOrderItem";
import Toast from "../../../common/toast";
import { QueryClient, useQueryClient } from "react-query";

const SuggestionMainItemInfo = ({
  item,
  sympoleData,
  tableQr,
  tableName,
  updataItem,
  favorites,
  handleFavorite,
  handleCloseItemDialog,
  onActionDone,
  treeData,
}) => {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [selected, setSelected] = useState();
  const [calorie, setCalorie] = useState();
  const [priceOption, setPriceOption] = useState();
  const [open, setOpen] = useState(false);
  const divRef = useRef(null);
  const [divWidth, setDivWidth] = useState(null);
  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });

  useEffect(() => {
    if (divRef.current) {
      const width = divRef.current.offsetWidth;
      setDivWidth(width);
    }
  }, []);

  const handleOpenToast = (message, status) => {
    const toast = { ...toastSettings };
    toast.open = true;
    toast.success = status === undefined ? true : status;
    toast.message = message;
    if (message === "Order has been added successfully") {
      queryClient.invalidateQueries(["basket-items", getLocalStorageMenuItem("lang")]);

      onActionDone(true);
    }
    setToastSettings(toast);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setToastSettings({ open: false, message: "", success: false });
  };


  const handleOrder = (status) => {

    if (treeData?.details?.is_available) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isFacebook = userAgent.includes('facebook') || userAgent.includes('fbav');
      const isInstagram = userAgent.includes('instagram');

      if (isFacebook || isInstagram) {
        if (/iphone|ipad|ipod/.test(userAgent)) {
          window.location.href = `googlechromes://${window.location.href.replace(/^https?:\/\//, '')}`;
          setTimeout(() => {
            window.location.href = `safari://${window.location.href.replace(/^https?:\/\//, '')}`;
          }, 500);

          setTimeout(() => {
            window.location.href = window.location.href;
          }, 1000);
        }
        else {
          window.location.href = `intent://${window.location.href.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
          setTimeout(() => {
            window.location.href = window.location.href;
          }, 500);
        }
      } else {
        setOpen(status);
      }
    } else {
      handleOpenToast(t("This menu is not avialable, check menu opining hours in the home screen"), false);
    }

  };


  const handleSelected = (element) => {
    try {
      const price_option_list = item?.has_price_option_item ? item?.price_option_items : item?.price_options;

      if (price_option_list) {
        const index = price_option_list.findIndex((option) => {
          return option.price == element.price;
        });
        setSelected(price_option_list[index].name);
        setCalorie(price_option_list[index].calories);
        setPriceOption(price_option_list[index]);
      }
    } catch (error) { }
  };

  const onImageError = (e) => {
    e.target.src = no_image;
  };

  const handleBack = () => {
    handleCloseItemDialog();
  };

  return (
    <div
      className={`main-items min-vh-100`}
      style={{
        color: setMobileTextColor(),
        backgroundColor: setMobileBackColor(),
        direction: "ltr",
      }}
    >
      <Container fluid>
        <div className="row">
          <div className="col-lg-4 ms-auto p-0" ref={divRef}>
            <div className="position-relative w-auto">
              <Carousel>
                <Carousel.Item>
                  {item?.image ? (
                    <img
                      className="d-block w-100 slide-image h-50"
                      alt="First slide"
                      src={item?.image}
                      onError={onImageError}
                    />
                  ) : (
                    <img
                      className="d-block w-100 slide-image h-50"
                      alt="First slide"
                      src={no_image}
                    />
                  )}

                  <Button
                    className={`fw-bold back fw-bold ${getLocalStorageMenuItem("lang") === "ar" ||
                      getLocalStorageMenuItem("lang") === "fa"
                      ? "end-0"
                      : "start-0"
                      }`}
                    style={{
                      backgroundColor: setMobileButttonBackColor(),
                      color: setMobileHighlightTextColor() || setMobileTextColor(),
                      border: "1px solid " + setMobileCardBorderColor(),
                      borderRadius: "8px",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    onClick={handleBack}
                  >
                    {getLocalStorageMenuItem("lang") === "ar" ||
                      getLocalStorageMenuItem("lang") === "fa" ? (
                      // <ArrowForwardIosOutlined />
                      <SvgDynamicIconComponent
                        icon_name="back"
                        is_arabic_lang={
                          getLocalStorageMenuItem("lang") === "ar" ||
                          getLocalStorageMenuItem("lang") === "fa"
                        }
                        color={setMobileHighlightTextColor() || setMobileTextColor()}
                      />
                    ) : (
                      // <ArrowBackIosOutlined />
                      <SvgDynamicIconComponent
                        icon_name="back"
                        is_arabic_lang={
                          getLocalStorageMenuItem("lang") === "ar" ||
                          getLocalStorageMenuItem("lang") === "fa"
                        }
                        color={setMobileHighlightTextColor() || setMobileTextColor()}
                      />
                    )}{" "}
                    <Link to="/selection" />
                  </Button>
                  <div>
                    <RWebShare
                      data={{
                        text: t("If You Like It Share It With Friends"),
                        url:
                          `/${tableName}/${tableQr}/items?item=${item?.id
                          }&t=${params.get("t")}&oneItem=${params.get(
                            "oneItem"
                          )}&` +
                          (params.get("selectedLang")
                            ? ""
                            : "selectedLang=" +
                            getLocalStorageMenuItem("lang") +
                            "&") +
                          "shared_item",
                      }}
                      sites={[
                        "facebook",
                        "twitter",
                        "whatsapp",
                        "reddit",
                        "telegram",
                        "linkedin",
                        "mail",
                        "copy",
                        "vk",
                        "okru",
                      ]}
                    >
                      <Button
                        className={`fw-bold share ${getLocalStorageMenuItem("lang") === "ar" ||
                          getLocalStorageMenuItem("lang") === "fa"
                          ? "start-0"
                          : "end-0"
                          } `}
                        style={{
                          backgroundColor: setMobileButttonBackColor(),
                          color: setMobileHighlightTextColor() || setMobileTextColor(),
                          border: "1px solid " + setMobileCardBorderColor(),
                          borderRadius: "8px",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {getLocalStorageMenuItem("lang") === "ar" ||
                          getLocalStorageMenuItem("lang") === "fa" ? (
                          <SvgDynamicIconComponent
                            icon_name="share"
                            is_arabic_lang={
                              getLocalStorageMenuItem("lang") === "ar" ||
                              getLocalStorageMenuItem("lang") === "fa"
                            }
                            color={setMobileHighlightTextColor() || setMobileTextColor()}
                          />
                        ) : (
                          <SvgDynamicIconComponent
                            icon_name="share"
                            is_arabic_lang={
                              getLocalStorageMenuItem("lang") === "ar" ||
                              getLocalStorageMenuItem("lang") === "fa"
                            }
                            color={setMobileHighlightTextColor() || setMobileTextColor()}
                          />
                        )}{" "}
                      </Button>
                    </RWebShare>
                  </div>
                </Carousel.Item>
              </Carousel>

              <div
                className="item-main-info-style"
                style={{
                  backgroundColor: setMobileBackColor(),
                }}
              >
                <div style={{ width: "100%", marginBottom: "85px" }}>
                  <div className="head mt-4 px-3">
                    {item.label_name ? (
                      <p className="mb-2 alignByLang">
                        <Badge
                          className={` ${getBadgeStatusClass(
                            item.label_name
                          )} p-2 font-size-12 sub-font m-1`}
                        >
                          {item.label_name || "New"}
                        </Badge>
                        {item?.sold_out !== 1 ? (
                          <Badge
                            className={`${getLocalStorageMenuItem("theme") === "dark"
                              ? "instock-badge-style-dark"
                              : "instock-badge-style"
                              }  p-2 font-size-12 sub-font m-1`}
                          >
                            {t("in stock")}
                          </Badge>
                        ) : (
                          <Badge
                            className={`${getLocalStorageMenuItem("theme") === "dark"
                              ? "outofinstock-badge-style-dark"
                              : "outofinstock-badge-style"
                              }  p-2 font-size-12 sub-font m-1`}
                          >
                            {t("Out of stock")}
                          </Badge>
                        )}
                      </p>
                    ) : (
                      <p className="mb-2 alignByLang">
                        <Badge
                          className={` ${getBadgeStatusClass(
                            "New"
                          )} p-2 font-size-12 sub-font m-1`}
                        >
                          {t("New")}
                        </Badge>
                        {item?.sold_out !== 1 ? (
                          <Badge
                            className={`${getLocalStorageMenuItem("theme") === "dark"
                              ? "instock-badge-style-dark"
                              : "instock-badge-style"
                              }  p-2 font-size-12 sub-font m-1`}
                          >
                            {t("in stock")}
                          </Badge>
                        ) : (
                          <Badge
                            className={`${getLocalStorageMenuItem("theme") === "dark"
                              ? "outofinstock-badge-style-dark"
                              : "outofinstock-badge-style"
                              }  p-2 font-size-12 sub-font m-1`}
                          >
                            {t("Out of stock")}
                          </Badge>
                        )}
                      </p>
                    )}
                  </div>

                  {item?.has_price_option_item && item?.price_option_items?.length > 0 ? (
                    <div className="alignByLang">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                        className="row px-3 m-0"
                      >
                        <div className="col-6 p-0">
                          <p
                            className="fw-bold mt-3 font-size-22 head-font"
                            style={{
                              textAlign:
                                getLocalStorageMenuItem("lang") === "ar" ||
                                  getLocalStorageMenuItem("lang") === "fa"
                                  ? "right"
                                  : "left",
                            }}
                          >
                            {item?.name}
                            <br /> ({selected}){" "}
                          </p>
                        </div>
                        <div className="col-6 p-0">
                          <Swiper
                            handleSelected={handleSelected}
                            prices={item?.price_option_items}
                            currency={sympoleData}
                          />
                        </div>
                      </div>
                    </div>
                  ) : item?.has_price_option_item && item?.price_options?.length > 0 ? (
                    <div className="alignByLang">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                        className="row px-3 m-0"
                      >
                        <div className="col-6 p-0">
                          <p
                            className="fw-bold mt-3 font-size-22 head-font"
                            style={{
                              textAlign:
                                getLocalStorageMenuItem("lang") === "ar" ||
                                  getLocalStorageMenuItem("lang") === "fa"
                                  ? "right"
                                  : "left",
                            }}
                          >
                            {item?.name}
                            <br /> ({selected}){" "}
                          </p>
                        </div>
                        <div className="col-6 p-0">
                          <Swiper
                            handleSelected={handleSelected}
                            prices={item?.price_options}
                            currency={sympoleData}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-between px-3 alignByLang">
                      <p
                        style={{ color: setMobileTextColor() }}
                        className="font-size-22 head-font"
                      >
                        {item?.name}
                      </p>

                      {/* <p
                        className="head-font"
                        style={{
                          color:
                            getLocalStorageMenuItem("theme") === "costomize"
                              ? setMobileTextColor()
                              : "#6ba5f2",
                        }}
                      >
                        <span>
                          {item?.old_price > 0 && (
                            <span
                              style={{
                                textDecoration: "line-through",
                                color: "red",
                              }}
                            >
                              {item.old_price || ""}
                            </span>
                          )}{" "}
                          {item?.price} {sympoleData ? sympoleData === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympoleData : ""}

                        </span>
                      </p> */}

                      <p
                        className="head-font"
                        style={{
                          color:
                            getLocalStorageMenuItem("theme") === "costomize"
                              ? setMobileTextColor()
                              : "#6ba5f2",
                        }}
                      >
                        <span style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}>
                          {item?.old_price > 0 && (
                            <span
                              style={{
                                textDecoration: "line-through",
                                color: "red",
                              }}
                            >
                              {item.old_price || ""}
                            </span>
                          )}
                          <span style={{ display: 'flex', alignItems: 'center' }}>
                            {item?.price}
                            {sympoleData ? sympoleData === "SAR" ?
                              <img
                                width={20}
                                height={20}
                                src={SARIconThemeColor()}
                                className="mr-1"
                                style={{
                                  marginLeft: getLocalStorageMenuItem("lang") === "ar" ||
                                    getLocalStorageMenuItem("lang") === "fa" ? '0' : '5px',
                                  marginRight: getLocalStorageMenuItem("lang") === "ar" ||
                                    getLocalStorageMenuItem("lang") === "fa" ? '5px' : '0',
                                }}
                              /> : sympoleData : ""}
                          </span>
                        </span>
                      </p>
                    </div>
                  )}

                  <div className="contents px-3 alignByLang">
                    {item?.price_options?.length > 0 && calorie > 0 ? (
                      <span
                        className="fw-bold sub-font mr-1"
                        style={{ color: setMobileTextColor() }}
                      >
                        <img src={calories} className="mr-1 calories_style" />{" "}
                        {`${calorie ? calorie : 0} ${t("cal")}`}
                      </span>
                    ) : (
                      item?.calories &&
                      item?.calories > 0 &&
                      item?.price_options?.length === 0 && (
                        <span
                          className={`head-font ${setMobileButttonBackColor()}`}
                        >
                          <img src={calories} className="mr-1 calories_style" />{" "}
                          {`${item?.calories ? item?.calories : 0} ${t("cal")}`}
                        </span>
                      )
                    )}

                    {/* {item?.max_preparation_time && item?.min_preparation_time ? (
                  <span
                    className="head-font mr-1"
                    style={{ color: setMobileTextColor() }}
                  >
                    <img src={time} className="mr-1 timer_style" />{" "}
                    {` ${
                      item?.max_preparation_time != 0
                        ? item?.max_preparation_time
                        : ""
                    } - ${
                      item?.min_preparation_time != 0
                        ? item?.min_preparation_time
                        : ""
                    }  ${t("min(s)")}`}{" "}
                  </span>
                ) : (
                  <></>
                )} */}

                    <span
                      className="head-font mr-1"
                      style={{ color: setMobileTextColor() }}
                    >
                      {(item?.max_preparation_time &&
                        item?.max_preparation_time >= 0) ||
                        (item?.min_preparation_time &&
                          item?.min_preparation_time >= 0) ? (
                        <img src={time} className="mr-1 timer_style" />
                      ) : (
                        ""
                      )}
                      {` ${item?.min_preparation_time === 0
                        ? item?.min_preparation_time
                        : !item?.min_preparation_time
                          ? ""
                          : item?.min_preparation_time
                        } ${(!item?.max_preparation_time &&
                          item?.max_preparation_time !== 0) ||
                          (!item?.min_preparation_time &&
                            item?.min_preparation_time !== 0)
                          ? ``
                          : `-`
                        }   ${item?.max_preparation_time === 0
                          ? item?.max_preparation_time
                          : !item?.max_preparation_time
                            ? ""
                            : item?.max_preparation_time
                        }           ${(item?.max_preparation_time &&
                          item?.max_preparation_time >= 0) ||
                          (item?.min_preparation_time &&
                            item?.min_preparation_time >= 0)
                          ? t("min(s)") + " "
                          : ""
                        }`}
                    </span>
                    {item?.description && (
                      <div className="mt-4">
                        <p
                          style={{ color: setMobileTextColor() }}
                          className="font-size-16 head-font mb-2"
                        >
                          {t("Description")}
                        </p>
                        <p
                          style={{
                            color: setMobileTextColor(),
                            fontWeight: 400,
                          }}
                          className="font-size-12 sub-font"
                        >
                          {" "}
                          {item?.description}
                        </p>
                      </div>
                    )}
                    <div className="mt-4">
                      {item?.warnings?.length > 1 && (
                        <p
                          style={{ color: setMobileTextColor() }}
                          className="font-size-16 head-font mb-2"
                        >
                          {t("warning ingredient")}
                        </p>
                      )}
                      <div style={{
                        padding: "6px",
                        display: "flex",
                        flex: 1,
                        flexDirection: "row",
                      }} className="col-12">
                        {item?.warnings?.map((element) => (
                          <span key={element.id} className="alignByLang">
                            <span
                              style={{ marginLeft: 2, marginRight: 5 }}
                              className="font-size-18 sub-font"
                            >
                              <img
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  marginLeft: 2,
                                  marginRight: 5,
                                }}
                                src={ISDARKTHEME(getLocalStorageMenuItem("theme") || treeData?.details?.mobile_settings?.theme, setMobileBackColor() || treeData?.details?.mobile_settings?.colorProps?.back) ? element?.icon_dark || element.icon : element?.icon_light || element.icon}
                                onError={onImageError}
                                alt="icon"
                              />
                              {element.name}
                            </span>
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div
                    className={`add-cart-button-containter`}
                    style={{
                      position: "fixed",
                      bottom: 5,
                      zIndex: 1000,
                      backgroundColor: setMobileBackColor(),
                      padding: 15,
                      textTransform: "uppercase",
                    }}
                  >
                    <div>
                      <span
                        className={`heart cursor`}
                        onClick={() => handleFavorite(item)}
                      >
                        {favorites.findIndex((fav) => fav.id === item?.id) !==
                          -1 ? (
                          <img
                            src={heart_full_active_svg}
                            className="heart"
                            style={{ width: "35px", height: "35px" }}
                            onError={onImageError}
                          />
                        ) : (
                          <img
                            src={ISDARKTHEME(getLocalStorageMenuItem("theme") || treeData?.details?.mobile_settings?.theme, setMobileBackColor() || treeData?.details?.mobile_settings?.colorProps?.back) ? heart_full_inactive_with_white : heart_full_inactive_svg}
                            className="heart"
                            style={{ width: "35px", height: "35px" }}
                            onError={onImageError}
                          />
                        )}
                      </span>
                    </div>
                    {!treeData?.details?.order_ability &&
                      !treeData?.details?.whatsapp ? (
                      true
                    ) : (
                      <MuiButton
                        className="btn text-center sub-font alignByLang mx-2 head-font"
                        style={{
                          backgroundColor: setMobileButttonBackColor(),
                          color: setMobileHighlightTextColor() || setMobileTextColor(),
                          width: "85%",
                          fontSize: "16px",
                          fontWeight: 600,
                          zIndex: 9999,
                          textTransform: "uppercase",

                          // display: open ? "none" : "block",
                        }}
                        onClick={() => handleOrder(true)}
                      >
                        {t("Add to cart")}
                      </MuiButton>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SuggestedOrderItem
            container={divRef}
            item={item}
            currency={sympoleData}
            selected={priceOption}
            handleOpenToast={handleOpenToast}
            width={divWidth}
            handleBack={() => handleBack()}
            tableName={tableName}
            tableQr={tableQr}
            handleOrder={handleOrder}
            open={open}
            close={() => setOpen(false)}
          />
        </div>
        <Toast
          open={toastSettings.open}
          message={toastSettings.message}
          resetToast={handleCloseToast}
          success={toastSettings.success}
        />
      </Container>
    </div>
  );
};

export default SuggestionMainItemInfo;
